<template>
  <v-navigation-drawer
      class="wgu-app-sidebar"
      ref="sidebar"
      :style="{ maxWidth: maxWidth }"
      :width=sidebarWidth
      v-model="sidebarOpen"
      style="height: calc(100% - 74px); top: 74px;"
      >
      <!-- Forward the default slot for sidebar content. -->
      <slot></slot>
      <!-- Sidebar toggle button -->
      <template v-slot:prepend>
        <v-btn size="small"
          class="wgu-app-sidebar-toggle-btn position-absolute px0"
          location="top right"
          color="_primary"
          @click="sidebarOpen = !sidebarOpen">
          <v-icon v-if="sidebarOpen">md:chevron_left</v-icon>
          <v-icon v-else>md:chevron_right</v-icon>
        </v-btn>
      </template>
      <!-- Invisible sidebar resizer -->
      <div v-if="resizable"
        class="wgu-app-sidebar-resizer"
        @mousedown.prevent="onResize"
      />
  </v-navigation-drawer>
</template>

<script>

import { WguEventBus } from '@/WguEventBus';
import { useGoTo, useDisplay } from 'vuetify';

function viewport2width (breakpoint) {
  switch (breakpoint.name) {
    case 'xs': return 320;
    case 'sm': return 380;
    case 'md': return 425;
    case 'lg': return 450;
    case 'xl': return 450;
  }

  return 450;
}

export default {
  name: 'wgu-app-sidebar',
  props: {
    width: { type: Number, required: false, default: 350 },
    minWidth: { type: Number, required: false, default: NaN },
    maxWidth: { type: String, required: false, default: '90%' },
    visible: { type: Boolean, required: false, default: true },
    autoScroll: { type: Boolean, required: false, default: true },
    scrollDuration: { type: Number, required: false, default: 500 },
    resizable: { type: Boolean, required: false, default: false }
  },
  setup () {
    const goTo = useGoTo();
    const { name } = useDisplay();
    const vueDisplayInfo = name.value;
    return { goTo, vueDisplayInfo };
  },
  computed: {
    sidebarWidth () {
      return viewport2width(this.vueDisplayInfo);
    }
  },
  data () {
    return {
      sidebarOpen: this.visible
      // sidebarWidth: viewport2width(this.$vuetify.breakpoint)
    }
  },
  /**
   * Initialize the sidebar.
   */
  created () {
    WguEventBus.$on('sidebar-scroll', comp => {
      this.scrollTo(comp);
    });
    WguEventBus.$on('sidebar-toggle', (open) => {
      // toggle or force a opening state of the sidebar
      if (typeof open === 'boolean') {
        this.sidebarOpen = open;
      } else {
        this.sidebarOpen = !this.sidebarOpen;
      }
    });
  },
  methods: {
    /**
     * Scroll to a module, if the 'autoScroll' option is enabled.
     * @param {string | HTMLElement | Vue} comp The component to scroll to.
     */
    scrollTo (comp) {
      if (this.autoScroll) {
        this.goTo(comp, {
          container: '.wgu-app-sidebar > .v-navigation-drawer__content',
          duration: this.scrollDuration
        });
      }
    },
    /**
     * Resize the sidebar, if the 'resizable' option is enabled.
     */
    onResize () {
      const sidebarEl = this.$refs.sidebar.$el.nextSibling;
      sidebarEl.style.transition = 'initial';

      // Resize on mouse move
      const onMouseMove = (e) => {
        document.body.style.cursor = 'ew-resize';
        let w = e.clientX;
        w = Number.isNaN(this.minWidth) ? w : Math.max(this.minWidth, w);
        w = Number.isNaN(this.maxWidth) ? w : Math.min(this.maxWidth, w);
        this.sidebarWidth = w;
      }
      document.addEventListener('mousemove', onMouseMove, false);

      // Stop the interaction on the next mouse up.
      const onMouseUp = () => {
        sidebarEl.style.transition = '';
        document.body.style.cursor = '';
        document.removeEventListener('mousemove', onMouseMove, false);
      }
      document.addEventListener('mouseup', onMouseUp, { once: true });
    }
  }
}
</script>
